module.exports = __webpack_public_path__ + "img/hy1.feb597e0.jpg";